import Swal from "sweetalert2";

// ── Helpers ───────────────────────────────────────────────────────────────────
const buildDateListHTML = (dates) =>
  dates
    .map(
      (d) => `
      <div class="holiday-item">
        <i class="mdi mdi-calendar"></i>
        <span>${d}</span>
      </div>`
    )
    .join("");

// ── Alert ─────────────────────────────────────────────────────────────────────
export const showHolidayConflictAlert = async (holidayDates = []) => {
  const result = await Swal.fire({
    title: "มีคำขอที่ตรงกับวันหยุด!",
    html: `
      <div class="holiday-wrapper">
        <p class="holiday-desc">พบคำขอที่ตรงกับวันหยุด ในวันที่</p>
        ${buildDateListHTML(holidayDates)}
        <p class="holiday-note">
          สามารถแก้ไขเพื่อเปลี่ยนวันได้ และหากไม่แก้ไข คำขอในวันดังกล่าว จะไม่ถูกสร้างขึ้น
        </p>
      </div>
    `,
    showCloseButton:  false,
    showCancelButton: true,
    showDenyButton:   true,
    confirmButtonText: "Save",
    denyButtonText:    "Edit",
    cancelButtonText:  "Cancel",
    confirmButtonColor: "#3b82f6",
    customClass: {
      popup:         "holiday-conflict-popup",
      confirmButton: "swal-btn-save",
      denyButton:    "swal-btn-edit",
      cancelButton:  "swal-popup-btn-cancel",
    },
    buttonsStyling: false,
  });

  if (result.isConfirmed) return "save";
  if (result.isDenied)    return "edit";
  return "cancel";
};